import { Link } from 'react-router-dom';
import { CATEGORY_TILES } from '../../../config/categories';
import styles from './CategoryTiles.module.css';

export function CategoryTiles() {
  return (
    <section className={styles.section}>
      <div className={styles.grid}>
        {CATEGORY_TILES.map((tile) => (
          <Link
            key={tile.id}
            to={`/catalog?category=${tile.categoryId}`}
            className={styles.tile}
          >
            <span className={styles.name}>{tile.name}</span>
            <div className={styles.imageWrap}>
              <img src={tile.image} alt={tile.name} className={styles.image} loading="lazy" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
